"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureInfoAccordion = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var SignatureInfoItem_1 = require("../SignatureInfoItem");
var mobx_react_1 = require("mobx-react");
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var react_intl_1 = require("react-intl");
var common_1 = require("../../../common");
var AccordionItemStatus_1 = require("./AccordionItemStatus");
var useStyles = core_1.makeStyles(function (theme) {
    var defaultBorder = theme.variables.palette.crypto.defaultBorder;
    return core_1.createStyles({
        accordionWrapper: {
            boxShadow: 'none',
        },
        accordionTitle: {
            padding: '0',
            borderBottom: "" + defaultBorder,
        },
        accordionContent: {
            padding: '10px 0',
            borderBottom: "" + defaultBorder,
        },
    });
});
exports.SignatureInfoAccordion = mobx_react_1.observer(function (props) {
    var signatureInfoList = props.signatureInfoList;
    var _a = react_1.default.useState(null), expandedPanelKey = _a[0], setExpandedPanelKey = _a[1];
    var classes = useStyles();
    var handleAccordionChange = function (panelKey) {
        return function (event, isExpanded) {
            setExpandedPanelKey(isExpanded ? panelKey : null);
        };
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, signatureInfoList.map(function (signatureInfo, index) {
        var key = signatureInfo.certificateOwner + index;
        return (react_1.default.createElement(core_1.Grid, { item: true, key: key, className: "signature-item-tab" },
            react_1.default.createElement(core_1.Accordion, { expanded: expandedPanelKey === key, onChange: handleAccordionChange(key), className: classes.accordionWrapper },
                react_1.default.createElement(core_1.AccordionSummary, { expandIcon: react_1.default.createElement(ExpandMore_1.default, { color: "primary", id: "signature-item-tab-open-button" }), className: classes.accordionTitle },
                    react_1.default.createElement(core_1.Grid, { container: true, item: true, justify: "space-between", alignItems: "center", wrap: "nowrap" },
                        react_1.default.createElement(core_1.Grid, { container: true, item: true, spacing: 2, direction: "column" },
                            react_1.default.createElement(core_1.Grid, { item: true },
                                react_1.default.createElement(core_1.Typography, { variant: "h6", component: "h5" },
                                    react_1.default.createElement(core_1.Box, { fontWeight: "500", fontSize: "17px" }, signatureInfo.certificateOwner))),
                            react_1.default.createElement(common_1.InfoLine, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "signDate" }), value: signatureInfo.signDate, isDate: true })),
                        react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(AccordionItemStatus_1.AccordionItemStatus, { signatureStatus: signatureInfo.status })))),
                react_1.default.createElement(core_1.AccordionDetails, { className: classes.accordionContent },
                    react_1.default.createElement(core_1.Grid, { container: true, direction: "column", spacing: 4 },
                        react_1.default.createElement(SignatureInfoItem_1.SignatureInfoItem, { signatureInfo: signatureInfo }))))));
    })));
});
